export const userColorByStatus: Record<UserStatus, string> = {
    working: "var(--jade-9)",
    unavailable: "var(--tomato-9)",
}
